import { render, staticRenderFns } from "./update-paperpile-details.html?vue&type=template&id=013e6a90&scoped=true&external"
import script from "./update-paperpile-details.js?vue&type=script&lang=js&external"
export * from "./update-paperpile-details.js?vue&type=script&lang=js&external"
import style0 from "./update-paperpile-details.scss?vue&type=style&index=0&id=013e6a90&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013e6a90",
  null
  
)

export default component.exports